export default "__VITE_ASSET__1e988dfd__"